import React, { useRef } from "react";
import "./Products.css";
import i1 from "../assets/i1.png";
import p1 from "../assets/p1.png";
import i2 from "../assets/i2.png";
import p2 from "../assets/p2.png";
import i3 from "../assets/i3.png";
import p3 from "../assets/p3.png";
import i4 from "../assets/i4.png";
import p4 from "../assets/p4.png";
import i5 from "../assets/i5.png";
import p5 from "../assets/p5.png";
import i6 from "../assets/i6.png";
import p6 from "../assets/p6.png";

const Products = () => {
  const sliderRef = useRef(null);

  const getScrollStep = () => {
    if (!sliderRef.current) return 0;

    const slider = sliderRef.current;
    const firstCard = slider.querySelector(".product-card");
    if (!firstCard) return slider.clientWidth;

    const cardWidth = firstCard.getBoundingClientRect().width;
    const sliderStyles = window.getComputedStyle(slider);
    const gap = parseFloat(sliderStyles.columnGap || sliderStyles.gap || "0") || 0;

    return Math.round(cardWidth + gap);
  };

  const scrollLeft = () => {
    const step = getScrollStep();
    sliderRef.current?.scrollBy({ left: -step, behavior: "smooth" });
  };

  const scrollRight = () => {
    const step = getScrollStep();
    sliderRef.current?.scrollBy({ left: step, behavior: "smooth" });
  };

  const products = [
    {
      img: p1,
      title: "All Paints Brush Categories Available",
      icon: i1,
    },
    {
      img: p2,
      title: "All Paints Categories Available",
      icon: i2,
    },
    {
      img: p3,
      title: "All Rollers & Trays Categories Available",
      icon: i3,
    },
    {
      img: p4,
      title: "All Spray Paints Categories Available",
      icon: i4,
    },
    {
      img: p5,
      title: "All Wood Care Categories Available",
      icon: i5,
    },
    {
      img: p6,
      title: "All Cement Categories Available",
      icon: i6,
    },
  ];

  return (
    <div className="products-wrapper">
      <div className="products-header">
        <h2>Products</h2>
        <div className="slide-buttons">
          <button onClick={scrollLeft}>&#8592;</button>
          <button onClick={scrollRight}>&#8594;</button>
        </div>
      </div>
      <div className="products-slider" ref={sliderRef}>
        {products.map((item, index) => (
          <div className="product-card" key={index}>
            <img src={item.img} alt="product" />
            <div
              className="product-meta"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginTop: "10px",
              }}
            >
              <span className="icon" style={{ display: "inline-flex" }}>
                <img src={item.icon} alt="icon" />
              </span>
              <p className="product-title" style={{ margin: 0 }}>
                {item.title}
              </p>
            </div>
            <button className="order-btn">Order Now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
